import DOMPurify from 'dompurify'
import { marked } from 'marked'

/**
 * Sanitise already-rendered HTML before it reaches dangerouslySetInnerHTML.
 *
 * DOMPurify strips scripts, event handlers and javascript: URLs while keeping
 * the class/title/data-* attributes our report and transcript markup relies on
 * (e.g. quote-reference spans). Use this for HTML produced by hand-rolled
 * renderers; use renderMarkdownSafe for raw markdown.
 */
export function sanitizeHtml(html: string): string {
    return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })
}

/**
 * Render untrusted markdown (LLM/user-derived report and transcript content) to
 * sanitised HTML. Always use this instead of marked.parse() directly when the
 * result feeds dangerouslySetInnerHTML — marked does not sanitise, so raw HTML
 * embedded in the markdown would otherwise execute.
 */
export function renderMarkdownSafe(md: string): string {
    return sanitizeHtml(marked.parse(md) as string)
}
